import { forwardRef, Suspense } from 'react';

import {
  CameraControlsButton,
  CamerapathPanel,
  CamerapathResetDialog,
  Features,
  FsetupDrawToolControls,
  FurnitureStats,
  HistoryControls,
  LoadingBanner,
  ResetMetadataDialog,
  RestrictedAreaDialog,
  SetupName,
  ToolControls,
  UserMenu,
} from '@spazious/dollhouse-shared';
import { Flex, FlexProps, FloatingPanel, ToolBar } from '@spazious/dollhouse-uikit';

import { SaveButton } from '../SaveButton/index.js';

export interface MainProps extends FlexProps {}

export const Main = forwardRef<HTMLDivElement, MainProps>(({ children, ...restProps }, ref) => {
  return (
    <Flex ref={ref} {...restProps}>
      <Flex>
        <ToolBar alignment="top-start">
          <FloatingPanel>
            <Flex column padding="var(--spacing-gap)">
              <FurnitureStats />
            </Flex>
          </FloatingPanel>
        </ToolBar>
        <ToolBar alignItems="flex-start" alignment="top-center">
          <FsetupDrawToolControls />
          <Features features="graphs.setup:editable">
            <Suspense>
              <UserMenu />
            </Suspense>
          </Features>
          <ToolControls />
          <CameraControlsButton />
        </ToolBar>
        <Features features="graphs.setup:editable">
          <ToolBar alignment="top-end">
            <SaveButton />
          </ToolBar>
        </Features>
        <ToolBar alignment="left-center">
          <FloatingPanel>
            <CamerapathPanel />
          </FloatingPanel>
        </ToolBar>
        <ToolBar alignment="right-center">
          <RestrictedAreaDialog />
          <ResetMetadataDialog />
          <CamerapathResetDialog />
        </ToolBar>
        <ToolBar alignment="bottom-start">
          <Features features="history">
            <HistoryControls />
          </Features>
        </ToolBar>
        <Features features="graphs.setup.name">
          <ToolBar alignment="bottom-center">
            <SetupName />
          </ToolBar>
        </Features>
        <ToolBar alignment="bottom-end">
          <LoadingBanner />
        </ToolBar>
      </Flex>
      <Flex>{children}</Flex>
    </Flex>
  );
});

export default Main;
